import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

export default function PrivateRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return <LoadingSpinner fullPage text="Loading..." />;
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    return children;
}
